import React from 'react';
import BaseButton from '~/components/views/common/buttons/BaseButton/BaseButton';
import { SharedButtonProps } from '~/components/views/common/buttons/types';

type Props = Omit<SharedButtonProps, 'color'>;

const PrimaryButton: React.FC<Props> = props => {
  return <BaseButton color="primary" {...props} />;
};

export default PrimaryButton;
